import React from 'react'

interface Props {
  color?: string
}

export const AddLocationIcon: React.FC<React.PropsWithChildren<Props>> = (
  props
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5V11"
        stroke={props.color || '#0F5FD7'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 8L5 8"
        stroke={props.color || '#0F5FD7'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9497 3.05026C15.6834 5.78393 15.6834 10.2161 12.9497 12.9497C10.2161 15.6834 5.78393 15.6834 3.05025 12.9497C0.316582 10.2161 0.316582 5.7839 3.05025 3.05026C5.78393 0.316582 10.2161 0.316582 12.9497 3.05026"
        stroke={props.color || '#0F5FD7'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
